import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  // 新用户激励主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=135987307
  {
    path: '/PowerNewUser',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-medal-PowerNewUser" */ '~/pages/PowerNewUser'
        )
    ),
  },
] as RouteConfig[]
